export const ACCOUNT_TYPES = {
    Customer: {
        id: 'customer',
        label: 'Customer',
        setting: 'accountTypeCustomers',
    },
    Prospect: {
        id: 'prospect',
        label: 'Prospect',
        setting: 'accountTypeProspects',
    },
    Churned: {
        id: 'churned',
        label: 'Churned',
        setting: 'accountTypeChurned',
    },
};
